/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { Button } from "@xo-union/tk-component-buttons";
import PropTypes from "prop-types";
import { Body1 } from "@xo-union/tk-ui-typography";
import styles from "../CloseConfirmModal/styles.css";
import SharedModal from "../shared/modal/index.js";
var TEXTS = {
  title: 'Retake the quiz?',
  resetResultsInfo: "This will reset your results which can’t be undone.",
  retakeQuiz: 'Retake quiz',
  cancel: 'Cancel'
};
export default function RetakeQuizConfirmModal(_ref) {
  var isOpen = _ref.isOpen,
    onCloseModal = _ref.onCloseModal,
    onRetakeQuiz = _ref.onRetakeQuiz;
  return /*#__PURE__*/React.createElement(SharedModal, {
    isOpen: isOpen,
    onClose: onCloseModal,
    containerClassName: styles['tk-modal-content'],
    wrapperClassName: styles['tk-modal-wrapper']
  }, /*#__PURE__*/React.createElement("h3", {
    className: styles['tk-modal-title']
  }, TEXTS.title), /*#__PURE__*/React.createElement(Body1, {
    as: "p",
    className: styles['tk-modal-subtitle']
  }, TEXTS.resetResultsInfo), /*#__PURE__*/React.createElement("div", {
    className: styles['tk-modal-action-buttons']
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    size: "lg",
    onClick: onRetakeQuiz,
    className: "".concat(styles['tk-modal-quit-button'], " ").concat(styles['tk-modal-button'])
  }, TEXTS.retakeQuiz), /*#__PURE__*/React.createElement(Button, {
    color: "tertiary",
    size: "md",
    onClick: onCloseModal,
    className: styles['tk-modal-button']
  }, TEXTS.cancel)));
}
process.env.NODE_ENV !== "production" ? RetakeQuizConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onRetakeQuiz: PropTypes.func
} : void 0;
RetakeQuizConfirmModal.defaultProps = {
  onRetakeQuiz: function onRetakeQuiz() {}
};